import { createFileRoute } from "@tanstack/react-router";
import { orpc } from "@/orpc/client";
import { ReferralLinkDataPage } from "@/pages/app-detail/referral-links/data/ReferralLinkDataPage";
import { ReferralLinkDataSkeleton } from "@/pages/app-detail/referral-links/data/ReferralLinkDataSkeleton";

export const Route = createFileRoute("/_app/apps/$appId/links/$linkId/data")({
	loader: async ({ context: { queryClient }, params }) =>
		queryClient.ensureQueryData(
			orpc.referralLinks.statistics.queryOptions({
				input: { id: params.linkId },
			}),
		),
	head: () => ({
		meta: [{ title: "Link Analytics - Biteasy" }],
	}),
	pendingComponent: ReferralLinkDataSkeleton,
	component: ReferralLinkDataPage,
});
